// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S76H","select":"styles_select__1vhvq"};